__turbopack_context__.v({
  "col": "styles-module-scss-module__9CxAkG__col",
  "root": "styles-module-scss-module__9CxAkG__root",
  "status": "styles-module-scss-module__9CxAkG__status",
});
